<template>
<div id="form-container" ref="formContainer">
  <b-button style="float:right;" type="button" variant="primary" @click="goBack">Back</b-button>
    <h1>Separation Request</h1>

    <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>

    <b-form v-if="!isSubmitted" @submit.stop.prevent="onSubmit">

                <div class="card-body">

                    <b-row>
                        <b-col cols="6">
                            <BaseTextOutput label="Employee Name"
                                    :value="request.employee.name" v-if="showPayrollView"/>
                        
                            <BaseEmployeeSelector v-model="request.employee"
                                label="Employee"
                                :v="$v.request.employee"
                                slug="employee"
                                tip=""
                                v-if="!showPayrollView"
                                :showPcn="true"/>
                            <div v-if="request.employee">
                                <strong>Employee Id:</strong>{{request.employee.employeeId}}<br/>
                                <strong>Employee PCN:</strong>{{request.employee.pcn}}<br/>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <BaseTextOutput :value="getBargainingUnitText(request.bargainingUnit)"
                                label="Bargaining Unit" v-if="showPayrollView"/>
                            <BaseSelector v-model="request.bargainingUnit" 
                                :v="$v.request.bargainingUnit"
                                label="Bargaining Unit"
                                slug="bargainingUnit"
                                :options=bargainingUnitOptions
                                v-if="!showPayrollView"
                                tip="" />
                        </b-col>
                    </b-row>
                
                </div>

                  <div class="card-header">Organizational Information</div>
        <div class="card-body">
            <b-row>
                <b-col cols="12" lg="4">
                <BaseTextOutput label="Division" :value="request.division" v-if="showPayrollView"/>
                    <BaseDivisionSelector v-model="request.division"
                        :v="$v.request.division"
                        :required="$v.request.division.$params.required ? true : false"
                        slug="division"
                        v-if="!showPayrollView"
                        label="Division"/>
                </b-col>
                <b-col cols="12" lg="4">
                                        <BaseTextOutput label="Department ID" :value="request.departmentId" v-if="showPayrollView"/>

                    <BaseDepartmentSelector v-model="request.departmentId"
                        :v="$v.request.departmentId"
                        :required="$v.request.departmentId.$params.required ? true : false"
                        slug="department"
                        v-if="!showPayrollView"
                        label="Department ID"/>
                </b-col>
            </b-row>
        </div>

          <b-row>
            <b-col cols="12" lg="4">    
            <BaseTextOutput label="Last Day Worked" :value="request.lastWorkedDate" v-if="showPayrollView"/>            
                <BaseDateInput v-model="request.lastWorkedDate" 
                    :v="$v.request.lastWorkedDate"
                    label="Last Day Worked"
                      v-if="!showPayrollView"
                    slug="start-date"/>
            </b-col>
            <b-col cols="12" lg="4">
                        <BaseTextOutput label="Effective for Pay Period Ending" :value="request.payPeriodEndingDate" v-if="showPayrollView"/>            

                <BaseDateInput v-model="request.payPeriodEndingDate" 
                    :v="$v.request.payPeriodEndingDate"
                    label="Effective for Pay Period Ending"
                    v-if="!showPayrollView"
                    slug="ppe-date"/>                    
            </b-col>
              <b-col cols="12" lg="4">
                                      <BaseTextOutput label="Separation Type" :value="request.separationType" v-if="showPayrollView"/>            

                        <BaseSelector v-model="request.separationType" 
                            :v="$v.request.separationType"
                            label="Separation Type"
                            slug="septype"
                            v-if="!showPayrollView"
                            :options = separationTypeOptions />
                    </b-col>        
        </b-row>

        <b-row>
                            <b-col cols="12" lg="4">
                            <BaseTextOutput label="Hourly Rate" :value="request.rate" v-if="showPayrollView"/>            

                        <BaseMoneyInput v-model="request.rate" 
                                :v="$v.request.rate"
                                slug="rate"
                                v-if="!showPayrollView"
                                label="Hourly Rate"/>
                    </b-col>
                    </b-row>

 <div class="card">
        <div class="card-header">Request Comments</div>
        <div class="card-body">
            <b-row>
                <b-col>
                 <BaseTextOutput label="Payout Instructions / Comments" :value="request.comments" v-if="showPayrollView"/>  
                    <BaseParagraphInput v-model="request.comments"
                        :v="$v.request.comments" 
                        label="Payout Instructions / Comments"
                        slug="comments"
                        v-if="!showPayrollView"
                        :required="$v.request.comments.$params.required ? true : false"
                        tip="Summarize in 1000 characters or less. Use attachments for more details as needed."/>
                </b-col>
            </b-row>  
        </div>
    </div>    

    <div class="card" v-if="showPayrollView">
        <div class="card-header">Payroll Transaction</div>
        <div class="card-body">
            <b-row>
                <b-col cols="12" lg="4">
                    <BaseTextOutput label="Vacation Eligible?" :value="request.vacationElig" v-if="!showPayrollView"/>  
                    <BaseSelector v-model="request.vacationElig" 
                            :v="$v.request.vacationElig"
                            label="Vacation Eligible?"
                            slug="velig"
                            v-if="showPayrollView"
                            :options = yesNoOptions />
                </b-col>
                <b-col cols="12" lg="4" v-if="request.vacationElig === 'Y'">
                    <BaseTextOutput label="Vacation Amount ($)" :value="request.vacationHours" v-if="!showPayrollView"/>  
                    <BaseMoneyInput v-model="request.vacationHours" 
                                :v="$v.request.vacationHours"
                                slug="vacationHours"
                                v-if="showPayrollView"
                                label="Vacation Amount ($)"/>
                </b-col>
                <b-col cols="12" lg="4" v-if="request.vacationElig === 'Y'">
                    <BaseTextOutput label="Payout Type" :value="request.vacationPayoutType" v-if="!showPayrollView"/>  
                    <BaseSelector v-model="request.vacationPayoutType" 
                            :v="$v.request.vacationPayoutType"
                            label="Payout Type"
                            slug="vpt"
                            v-if="showPayrollView"
                            :options = payoutTypeOptions />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" lg="4">
                    <BaseTextOutput label="Severance Eligible?" :value="request.severanceElig" v-if="!showPayrollView"/>  
                    <BaseSelector v-model="request.severanceElig" 
                            :v="$v.request.severanceElig"
                            label="Severance Eligible?"
                            slug="selig"
                            v-if="showPayrollView"
                            :options = yesNoOptions />
                </b-col>
                <b-col cols="12" lg="4" v-if="request.severanceElig === 'Y'">
                    <BaseTextOutput label="Severance Amount ($)" :value="request.severancePayout" v-if="!showPayrollView"/>  
                    <BaseMoneyInput v-model="request.severancePayout" 
                                :v="$v.request.severancePayout"
                                slug="severancePayout"
                                v-if="showPayrollView"
                                label="Severance Amount ($)"/>

                </b-col>
                <b-col cols="12" lg="4" v-if="request.severanceElig === 'Y'">
                    <BaseTextOutput label="Payout Type" :value="request.severancePayoutType" v-if="!showPayrollView"/>  
                    <BaseSelector v-model="request.severancePayoutType" 
                            :v="$v.request.severancePayoutType"
                            label="Payout Type"
                            slug="spt"
                            v-if="showPayrollView"
                            :options = payoutTypeOptions />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" lg="4">
                    <BaseTextOutput label="Health Care Retirement" :value="request.healthCareRetirement" v-if="!showPayrollView"/>  
                    <BaseSelector v-model="request.healthCareRetirement" 
                            :v="$v.request.healthCareRetirement"
                            label="Health Care Retirement"
                            slug="hcr"
                            v-if="showPayrollView"
                            :options = hcrOptions />
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseTextOutput label="Comp Payout Hours" :value="request.compPayout" v-if="!showPayrollView"/>  
                    <BaseMoneyInput v-model="request.compPayout" 
                                :v="$v.request.compPayout"
                                slug="compPayout"
                                v-if="showPayrollView"
                                label="Comp Payout Hours"/>

                </b-col>
                <b-col cols="12" lg="4">
                    <BaseTextOutput label="Remove Sick Hours (SIK)" :value="request.removeSick" v-if="!showPayrollView"/>  
                    <BaseSelector v-model="request.removeSick" 
                            :v="$v.request.removeSick"
                            label="Remove Sick Hours (SIK)"
                            slug="sik"
                            v-if="showPayrollView"
                            :options = yesNoOptions />
                </b-col>
            </b-row>  
            <b-row>
                <b-col cols="12" lg="4">
                    <b-form-checkbox v-model="removeRights" name="complete-switch" 
                        :v="$v.removeRights"
                        v-if="showPayrollView"
                        data-test="complete-switch" switch>
                            <b>Remove Approval Rights</b>
                        </b-form-checkbox>
                </b-col>
            </b-row>
        </div>
    </div>      

    <div v-if="!showPayrollView">
        <b-button type="submit" variant="primary">Submit</b-button>
    </div>
    <div v-if="showPayrollView">
        <b-button type="button" variant="primary" @click="updateRequest(true)"
            :disabled="!removeRights && removeRights != true">Complete</b-button>
        <b-button type="button" variant="outline-primary" @click="updateRequest(false)">Save</b-button>
    </div>
</b-form>
<div v-else>
    <strong>The form has been submitted.</strong>
    <p>This request was assigned a tracking number of {{ assignedId }}.</p>
</div>
</div>

</template>

<script>
import axios from "axios"
import _ from "lodash"
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf, ref, minValue, maxValue, helpers, decimal } from 'vuelidate/lib/validators'
import isDivisionValid from '@/validators/isDivisionValid.js'
import minDate from '@/validators/minDate.js'
import { commonOptions } from '@/mixins/commonOptions.js'
import axiosRetry from 'axios-retry'
import SecureLS from "secure-ls"
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import {roleService} from "@/mixins/roleService";
const agcyValidator = (value) => !helpers.req(value) || (value >= 40000 && value <= 40002)

axiosRetry(axios, { retries: 3,
                    retryDelay: axiosRetry.exponentialDelay  })

export default {
    components: {
    },

    mixins: [
       commonOptions,
       roleService,
    ],

    data() {
        return {
            requestId: null,
            isSubmitted: false,
            assignedId: '',
            removeRights: null,
            request: { 
                requestTypeValue: {
                    code: null,
                    text: '',
                },
            },
              
            defaultRequestAttributes: {
                lastWorkedDate: null, 
                payPeriodEndingDate: null, 
                division: '',
                departmentId: '',
                comments: '',
                requestTypeValue: {
                    code: null,
                    text: '',
                },
            },
            
            options: {
                format: 'YYYY-MM-DD',
                useCurrent: false,
            }, 
        }
    },

     watch: {        
    },

    computed: {
        _: function() {
            return _
        },

       showPayrollView() {
        return this.requestId && this.isPayroll()
       }
    },

    validations() {
        return {
            removeRights: {
                required: requiredIf(function() {
                    return this.showPayrollView 
                }),
            },
            request: {     

                bargainingUnit: { required },
                separationType: {required },  
                rate: { decimal, 
                    required
                },
                
                division: { 
                    required,
                    isDivisionValid 
                },

                departmentId: { 
                    required,
                },

                employee: {
                    employeeId: {
                        required
                    }
                }, 

                comments: { 
                    required: false, 
                    maxLength: maxLength(4000)
                },

                requestTypeValue: {
                    code: { 
                        required: true 
                    }
                },
                
                lastWorkedDate: { 
                    required,
                },
                payPeriodEndingDate: { 
                    required,
                    minDate: minDate(this.request.anticipatedStartDate)
                },

                vacationElig: { 
                    required: requiredIf(function() {
                        return this.showPayrollView 
                      })
                 },
                vacationHours: {
                      required: requiredIf(function() {
                        return this.showPayrollView && this.request.vacationElig === 'Y'
                      })
                },
                vacationPayoutType: {
                    required: requiredIf(function() {
                        return this.showPayrollView && this.request.vacationElig === 'Y'
                      })
                },

                severanceElig: { 
                    required: requiredIf(function() {
                        return this.showPayrollView 
                      })
                 },
                severancePayout: {
                      required: requiredIf(function() {
                        return this.showPayrollView && this.request.severanceElig === 'Y'
                      })
                },
                severancePayoutType: {
                    required: requiredIf(function() {
                        return this.showPayrollView && this.request.severanceElig === 'Y'
                      })
                },

                healthCareRetirement: {
                      required: requiredIf(function() {
                        return this.showPayrollView 
                      })
                },
                compPayout: {
                      required: requiredIf(function() {
                        return this.showPayrollView
                      })
                },
                removeSick: {
                      required: requiredIf(function() {
                        return this.showPayrollView
                      })
                },


            }
        }
    },

    created() { 
        this.requestId = this.$route.params.id
        if (this.requestId) {
            this.fetchRequest()
            window.scrollTo(0,0)
        } else {
            this.request = Object.assign(this.defaultRequestAttributes )
        }
    },

    methods: {
        
        onSubmit() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$nextTick(() => {
                    document.getElementById('form-container').scrollIntoView()
                })
                return
            }
            this.sendToServer()
        },
        
        sendToServer() {
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/separation`, this.request)
                .then(response => { 
                    this.isSubmitted = true
                    this.assignedId = response.data.id
            })
        },

        updateRequest(completed) {
            if (completed) {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            this.request.complete = completed
            
            axios.put(`${process.env.VUE_APP_API_BASE_URL}/separation`, this.request)
                .then(response => { 
                    this.showRootToast("Payroll Transaction Updated", "The Separation Payout has been updated.", "success")
                    if (completed) {
                        this.$router.push('/home')
                    }
            })
        },
        
        fetchRequest() {
            this.initialPageLoading = true
             axios.get(`${process.env.VUE_APP_API_BASE_URL}/separation/${this.requestId}`)
                .then(response => {
                    this.initialPageLoading = false
                    this.request = _.merge(this.defaultRequestAttributes, response.data)
                    console.log(this.request)
                })
        },

        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })
        },
      goBack(){
        //Requests is routed twice, so we need to go back 2 in order to get to the right place
        this.$router.back()
      },
      getBargainingUnitText(bargainingUnitCode){
        return this.bargainingUnitOptions.find(code => code.value === bargainingUnitCode).text
      }
    }   
}
</script>

<style>
.card {
    margin-bottom: 18px;
}
.card-header {
    font-weight: 700;
}

fieldset > legend {
    font-weight: 750;
}
</style>